import React, {
    SetStateAction, useEffect, useState, Dispatch as ReactDispatch,
} from "react";
import {selectSignedResourceUrl} from "@data-force/app";
import {useDispatch, useSelector} from "react-redux";
import {Dispatch} from "redux";
import {processResourceUrl} from "../../store/actions/job";
import {createSignedResourceKey, updateResourceProps} from "./utils";
import {MediaProps, UpdatedMediaProps} from "./types";

const MarkdownVideo: React.FC = (props: MediaProps): React.ReactElement => {
    const [errorCounter, setErrorCounter]: [number, ReactDispatch<SetStateAction<number>>] = useState(0);
    const videoProps: UpdatedMediaProps = updateResourceProps(props);
    const {
        src, signType, children, updatedProps, isLegacySign,
    }: UpdatedMediaProps = videoProps;

    const signedResourceUrl: string | undefined = useSelector(selectSignedResourceUrl(createSignedResourceKey({
        fileReference: src,
        signType,
    })));
    const dispatch: Dispatch = useDispatch();

    useEffect(() => {
        dispatch(processResourceUrl({
            fileReference: src,
            signType,
            isLegacySign,
        }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    /**
     * When successfully loaded, reset error counter
     * @returns {void}
     */
    const handleLoad = (): void => {
        setErrorCounter(0);
    };

    /**
     * Re-sign resource, if token expires
     * @returns {void}
     */
    const handleError = (): void => {
        if (errorCounter < 2) {
            dispatch(processResourceUrl({
                fileReference: src,
                signType,
                isLegacySign,
                resign: true,
            }));
            setErrorCounter(errorCounter + 1);
        }
    };

    return (
        <>
            {signedResourceUrl && (
                <video
                    {...updatedProps}
                    key={signedResourceUrl}
                >
                    <source
                        src={signedResourceUrl}
                        onError={handleError}
                        onLoad={handleLoad}
                    />
                    <track kind="captions"/>
                    {children}
                </video>
            )}
        </>
    );
};

export default MarkdownVideo;
